import React, {
  Component
} from 'react';
import './../style/loading.css';

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true,
      timer: null
    }
  }

  componentDidMount() {
    const me = this;
    if (this.props.display) {
      let timer = setTimeout(function () {
        me.setState({
          display: false
        })
      }, 50000);

      me.setState({ timer: timer });
    }
  }

  componentWillUnmount() {
    this.setState({ timer: null, display: true });
  }


  render() {
    let {
      display
    } = this.state;
    return (
      <div>
        {this.props.display && display && (typeof this.props.classtype === 'undefined' || this.props.classtype === '' || this.props.classtype === 'loader1') &&
          <div className="loader loader1">
            <div className="loader-outter"></div>
            <div className="loader-inner"></div>
          </div>
        }

        {this.props.display && display && this.props.classtype === 'loader3' &&
          <div className="loader loader3">
            <div className="dot dot1"></div>
            <div className="dot dot2"></div>
            <div className="dot dot3"></div>
          </div>
        }
        {this.props.display && display &&
          <div className="loading-backdrop fade show"></div>
        }
      </div>
    )
  }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading.js